// src/contexts/DeviceContext.js
import React, { createContext, useContext } from 'react';

const DeviceContext = createContext();

export const useDevice = () => {
  const context = useContext(DeviceContext);
  if (!context) {
    throw new Error('useDevice must be used within DeviceProvider');
  }
  return context;
};

export const DeviceProvider = ({ children, deviceType }) => {
  const isMobile = deviceType === 'mobile';
  const isTablet = deviceType === 'tablet';
  const isDesktop = deviceType === 'desktop';
  const isTouchDevice = isMobile || isTablet;

  const value = {
    deviceType,
    isMobile,
    isTablet,
    isDesktop,
    isTouchDevice
  };

  return (
    <DeviceContext.Provider value={value}>
      {children}
    </DeviceContext.Provider>
  );
};